import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-base/baseVacationInfo/vacationList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
const getMyLeaveInfo = (current, size, params) => request({
  url: '/api/mcc-staff/vacation/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-base/baseVacationInfo/vacationSave',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-base/baseVacationInfo/vacationDetail',
  method: 'get',
  params: {
    ...params,
  },
})

const vacationDetail = params => request({
  url: '/api/mcc-staff/vacation/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const update = params => request({
  url: '/api/mcc-staff/vacation/submit',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-staff/vacation/remove',
  method: 'post',
  params: {
    ids,
  },
})

// 获取年假记录
export const getAnnualDays = params => request({
  url: '/api/mcc-worker/vacation/haveWorkerDays',
  method: 'get',
  params: {
    ...params,
  },
})

const downLoadExcel = params => request({
  // url: '/api/mcc-base/baseVacationInfo/excel',
  url: '/api/mcc-staff/vacation/excel',
  method: 'get',
  responseType: 'blob',
  params: {
    size: -1,
    ...params,
  },
})

const getMyLeaveRecordDays = params => request({
  url: '/api/mcc-staff/leaverecord/myLeaveRecordDays',
  method: 'get',
  params: {
    ...params,
  },
})

export const getVacationRecordsByMonth = params => request({
  url: '/api/mcc-staff/leaverecord/monthSummary',
  method: 'get',
  params: {
    ...params,
  },
})

export default {
  getList,
  add,
  detail,
  update,
  remove,
  vacationDetail,
  downLoadExcel,
  getMyLeaveRecordDays,
  getMyLeaveInfo,
  getVacationRecordsByMonth,
}
